export const HYBRID_FLAG_KEY = "hybrid_registration_started";

export function decideResumeRoute(hasSession, hasFlag) {
  if (hasSession) return "stay";
  if (!hasFlag) return "welcome";
  return "password";
}

function getStorage() {
  return typeof localStorage === "undefined" ? null : localStorage;
}

export function readHybridFlag() {
  try {
    const storage = getStorage();
    return storage ? storage.getItem(HYBRID_FLAG_KEY) === "1" : false;
  } catch {
    // вкладка/private mode: Storage может бросить — флаг считаем отсутствующим
    return false;
  }
}

export function writeHybridFlag() {
  try {
    const storage = getStorage();
    if (storage) storage.setItem(HYBRID_FLAG_KEY, "1");
  } catch {
    // вкладка/private mode: не падаем, если диск недоступен
  }
}

export function clearHybridFlag() {
  try {
    const storage = getStorage();
    if (storage) storage.removeItem(HYBRID_FLAG_KEY);
  } catch {
    // вкладка/private mode: ключ мог не записаться — игнорируем
  }
}

export const HYBRID_SESSION_KEY = "hybrid_registration_session";

/**
 * Сохраняет blob для cold poll после F5 (poll A + max_bind_token).
 * Не логировать токены (T-04-13).
 */
export function writeHybridSession(session) {
  try {
    const storage = getStorage();
    if (!storage || !session) return;
    storage.setItem(HYBRID_SESSION_KEY, JSON.stringify(session));
  } catch {
    // вкладка/private mode: не падаем, если диск недоступен
  }
}

export function readHybridSession() {
  try {
    const storage = getStorage();
    if (!storage) return null;
    const raw = storage.getItem(HYBRID_SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    // private mode или битый JSON — blob считаем отсутствующим
    return null;
  }
}

export function clearHybridSession() {
  try {
    const storage = getStorage();
    if (storage) storage.removeItem(HYBRID_SESSION_KEY);
  } catch {
    // вкладка/private mode: ключ мог не записаться — игнорируем
  }
}

/**
 * Чистая карта статуса poll → destination для cold resume (D-106 / D-110).
 * Без флага всегда start — не открываем пароль/ожидание «вхолостую».
 */
export function coldResumeFromStatus(status, hasFlag) {
  if (!hasFlag) return "start";
  if (status === "verified") return "password";
  if (status === "pending") return "waiting";
  return "start";
}
